import { useContext, useEffect, useState } from "react";
import { RouteDashboard, RouteLogin, RouteRoot } from "../../PathRoutes";
import { useFetchServices } from "../hooks/useFetchServices";
import { useToast } from "../hooks/useMyScripts";
import Url, { useCookie } from '../LocalService';

export const Actions = () => {
    let [logado, setLogado] = useState(null);
    let cookie = useCookie();
    let toast = useToast();
    let fetchservice = useFetchServices();

    const doLogin = (value) => {
        let content = {
            login: value,
        };
        toast.toast("Aguarde, validando a chave...");
        /*
        fetch(Url + "autorizacao.dologin.php", {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify(content),
            }).then((res) => {
                return res.json();
            })*/
            fetchservice.executeService({
                method:"POST",
                endpoint:"autorizacao.dologin.php",
                body:content,
            })
            
            .then((data) => {
                if (data.success){
                    //document.cookie = "AppAuthOB="+data.token;
                    //document.cookie = "UserOB="+data.nome;
                    cookie.set("AppAuthOB",data.token);
                    cookie.set("UserOB",data.nome);
                    cookie.set("Perfil",data.perfil);
                    toast.toastSuccess("Bem vindo "+data.nome+"!");
                    window.location.replace(RouteDashboard);
                } else {
                    toast.toastError("Chave inválida!");
                    toast.toastInformation("Favor, consulte o administrador");
                }
                return data.success;
            }).catch((err) => {
                console.log(err);
            });
    };

    const checkLogin = () => {        
        let value = cookie.get("AppAuthOB");
        let dataBody = {
            token:value,
        };
        let saida = false;
        /*fetch(Url + "autorizacao.check.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataBody),
        })
        .then((res) => {
            return res.json();
        })*/
        fetchservice.executeService({
            method:"POST",
            endpoint:"autorizacao.check.php",
            body:dataBody,
        })
        .then((d) => {
            saida = d.success;
            setLogado(saida);            
            if (!d.success && window.location.pathname !== RouteLogin && window.location.pathname !== RouteRoot){
                toast.toastInformation("Chave expirada! Faça novamente o login...");
                window.location.replace(RouteLogin);
            } else {
                d.data.map((item) => {cookie.set("Perfil",item.perfil)});                
                if (cookie.get("Perfil") === "view" && window.location.pathname !== RouteDashboard){
                    toast.toastInformation("O seu perfil não tem permissão de acesso a essa rota!");
                    window.location.replace(RouteDashboard);
                }
            }
        })
        .catch((err) => {
            saida = false;
            setLogado(saida);
            console.log(err);
        });
        return saida;
    };

    return{
        logado,
        doLogin,
        checkLogin,
    }
}